import { render } from "./axisX.vue?vue&type=template&id=6413f0c4&scoped=true"
import script from "./axisX.vue?vue&type=script&lang=js"
export * from "./axisX.vue?vue&type=script&lang=js"

import "./axisX.vue?vue&type=style&index=0&id=6413f0c4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Usuario\\Documents\\Git-Repositorios\\edge_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6413f0c4"]])

export default __exports__